<dt-modal-content (closeClick)="close()" size="small" [contentPadding]="false">
  <ng-template #title i18n>Aufgabe zuweisen</ng-template>

  <ng-template #content>
    <mat-stepper orientation="vertical" [linear]="true" [selectedIndex]="taskTypeLocked ? 1 : 0" [class.task-type-locked]="taskTypeLocked">
      @if (taskTypeLocked) {
        <ng-template matStepperIcon="done">
          <mat-icon>lock</mat-icon>
        </ng-template>
      }

      <mat-step [stepControl]="taskTypeForm" [editable]="!taskTypeLocked" [completed]="taskTypeLocked">
        <form [formGroup]="taskTypeForm">
          <ng-template matStepLabel i18n>Aufgabentyp: {{ selectedTaskName }}</ng-template>
          <mat-form-field>
            <mat-label i18n>Aufgabentyp</mat-label>
            <mat-select formControlName="taskType">
              @for (taskType of taskTypes; track taskType) {
                <mat-option [value]="taskType.type">
                  {{ taskType.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
        <div>
          <button mat-button matStepperNext i18n>Weiter</button>
        </div>
      </mat-step>
      @if (taskOptions) {
        <mat-step [stepControl]="taskOptions">
          <ng-template matStepLabel i18n>Aufgabenoptionen</ng-template>
          <form [formGroup]="taskOptions">
            @if (selectedTaskType === 'objective-scale') {
              <mat-form-field>
                <mat-label i18n>Ziel</mat-label>
                <mat-select formControlName="objectiveUUID">
                  @for (objective of teamCalc.aggregatedProject.objectives; track objective) {
                    <mat-option [value]="objective.uuid">
                      {{ objective.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <div>
              <button mat-button matStepperNext i18n>Weiter</button>
            </div>
          </form>
        </mat-step>
      }
      <mat-step>
        <ng-template matStepLabel i18n>Zuweisen zu</ng-template>
        <mat-selection-list #selectedMembers i18n-empty-text empty-text="Diese Aufgabe wurde bereits jedem Teammitglied zugewiesen">
          @for (member of members; track member) {
            @if (shouldShowMember(member)) {
              <mat-list-option [value]="member">
                <dt-team-member-name [showEmailWhenNoName]="true" [member]="member"></dt-team-member-name>
              </mat-list-option>
            }
          }
        </mat-selection-list>
      </mat-step>
    </mat-stepper>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="closeWithAssignedTask()" [disabled]="!formValid" i18n>Zuweisen</button>
    <button mat-stroked-button color="accent" (click)="close()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
